import { sfOr } from 'spring-filter-query-builder';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const makeLockoutDefaultFilter = (searchValue: string): string =>
    sfOr([
        sfLike('code', `${escapeSfqbString(searchValue, true)}*`, true),
        sfLike('description', `*${escapeSfqbString(searchValue, true)}*`, true),
    ]).toString();
